<template>
  <ul class="">
    <li
      class="

          first-line
          fs-16
          flex flex-row
          items-center
          pt-8
          pb-8
          "
      :class="windowWidth < PHONE ? 'bd-gray-300-new bd-b-d-1' : ''"
    >
      <img
        :src="`${ASSETS_CDN}/icons/enquire.svg`"
        alt=""
        class="mr-12"
      />
      <div>
        <p class="mb-0 fw-700 lh-28 fs-20 tl-fs-14 tl-fw-600 tl-lh-20">
          Enquire
        </p>
        <p class="other-lines fw-400 tl-fs-14 tl-lh-20 fs-16 lh-24 mb-0">
          Let us know your travel requirements.
        </p>
      </div>
    </li>
    <li
      class="

          first-line
          fs-16
          flex flex-row
          items-center
          pt-8
          pb-8

          "
      :class="windowWidth < PHONE ? 'bd-gray-300-new bd-b-d-1' : ''"
    >
      <img
        :src="`${ASSETS_CDN}/icons/design.svg`"
        alt=""
        class="mr-12"
      />
      <div>
        <p class="mb-0 fw-700 lh-28 fs-20 tl-fs-14 tl-fw-600 tl-lh-20">
          Design
        </p>
        <p class="other-lines fw-400 tl-fs-14 tl-lh-20 fs-16 lh-24 mb-0">
          Design your trip plan with our expert local designers, for free.
        </p>
      </div>
    </li>
    <li
      class="

          first-line
          fs-16
          lh-18
          flex flex-row
          items-center
          pt-8
          pb-8
          "
      :class="windowWidth < PHONE ? 'bd-gray-300-new bd-b-d-1' : ''">
      <img
        :src="`${ASSETS_CDN}/icons/book.svg`"
        alt=""
        class="mr-12"
      />
      <div>
        <p class="mb-0 fw-700 lh-28 fs-20 tl-fs-14 tl-fw-600 tl-lh-20">
          Book
        </p>
        <p class="other-lines fw-400 tl-fs-14 tl-lh-20 fs-16 lh-24 mb-0">
          Book with confidence with our secure booking platform, backed by our comprehensive Traveller Protections.
        </p>
      </div>
    </li>
    <li
      class="
          first-line
          fs-16
          lh-18
          flex flex-row
          items-center
          pt-8
          pb-8
          ">
      <img
        :src="`${ASSETS_CDN}/icons/travel.svg`"
        alt=""
        class="mr-12"
      />
      <div>
        <p class="mb-0 fw-700 lh-28 fs-20 tl-fs-14 tl-fw-600 tl-lh-20">
          Travel
        </p>
        <p class="other-lines fw-400 tl-fs-14 tl-lh-20 fs-16 lh-24 mb-0">
          Travel with complete peace of mind, supported every step of the way.
        </p>
      </div>
    </li>

  </ul>
</template>
<script>
import {PHONE} from '~/constant/common'
import {computed} from "vue";
import {assetCDN} from '~/helper/index.js';
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
export default {
  data() {
    return {
      PHONE
    }
  },
  setup() {
    const ASSETS_CDN = assetCDN()
    const generalStore = useGeneralInfoStore()
    
    const windowWidth = computed(() => generalStore.generalData.windowWidth)
    return {ASSETS_CDN , windowWidth}
  }
}
</script>
